import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { WebPart } from "../models/web-part.model";

export type LookUpDto = {
  name: string,
  value: string
}

@Injectable({
  providedIn: "root"
})
export class LookUpService {

  public webPageNames(): Observable<LookUpDto[]> {
    return of([
      {
        name: 'Welcome',
        value: 'welcome'
      },
      {
        name: 'Footer',
        value: 'footer'
      }
    ]);
  }

  public languages(): Observable<{ value: string, displayName: string }[]> {
    return new BehaviorSubject([
      { value: "en-CA", displayName: "en_ca" },
      { value: "fr-CA", displayName: "fr_ca" },
      { value: "en-US", displayName: "en_us" },
    ] as any[]);
  }

  public webPartNames(page: string): Observable<WebPart[]> {
    return of([
      {
        name: "Header",
        id: "1",
        display: "Header"
      }
    ]);
  }


}


export const provinces = [
  "NL", "PE", "NS", "NB", "QC", "ON", "MB", "SK", "AB", "BC", "YT", "NT", "NU"
];